import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateGroupMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.groupsCreate,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useDeleteGroupMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.groupsDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
